import View from './view'
import {combineStates, context, reducer} from "../../support/join_contexts_HOC";
import {component_reducer, dispatchToProps, initState} from "./local_state/reducer";
import {JoinedTypePropsType, OwnPropsType} from "./index.types";
import {EventPropsType, InputPropsType} from "./view.types";
import {PopUpContext} from "../../support/pop_up";
import {createElement} from "react";
import ProcessPendingFilm from "./components/process_pending_film_modal";
import {getOnePendingFilm, patchPendingFilmToReview} from "../../support/network/requests/pending_films";
import Network from "../../support/network";
import {PendingFilmType} from "../../models/pending_film";
import * as FilmRequest from "../../support/network/requests/films";
import * as PendingFilmRequest from "../../support/network/requests/pending_films";
import * as PendingCommandRequest from "../../support/network/requests/pending_command";
import {FilmType} from "../../models/film";
import {ReviewFilmType} from "./local_state/reducer.types";
import {pendingFilmId} from "./local_state/reducer.constants";
import {encodePathToFileName} from "../../utils/file_system";
import {createParamsComponent} from "../../support/navigation/components/params_hoc";

function getPendingFilm(ownProps: OwnPropsType & JoinedTypePropsType) {
    Network.instance.netClient.executeRequest(getOnePendingFilm(async (res) => {
        console.log(res)
        modifyPendingFilm(res, ownProps)
    }, () => {
    }))
}

function setPendingFilmToReview(filmId: number, onSuccess: () => void) {
    Network.instance.netClient.executeRequest(patchPendingFilmToReview(filmId, async (res) => {
        console.log(res)
        onSuccess()
    }, () => {
    }))
}

function modifyPendingFilm(film: PendingFilmType | undefined, ownProps: OwnPropsType & JoinedTypePropsType){
    if (!film) return
    const modal = createElement(ProcessPendingFilm, {
        pending_film: film,
        onPendingFilmReviewed: async film => {
            ownProps.popUp.hidePopUp()
            let imdbMatches: FilmType[] | undefined = undefined
            if (film.imdbId) {
                imdbMatches = await new Promise((resolve) => {
                    Network.instance.netClient.executeRequest(FilmRequest.getFilms({imdb_id: film.imdbId?.id}, (res) => {
                        resolve(res)
                    }, () => {
                        resolve([])
                    }))
                })
            }
            let filmaMatches: FilmType[] | undefined = undefined
            if (film.filmaffinityId) {
                filmaMatches = await new Promise((resolve) => {
                    Network.instance.netClient.executeRequest(FilmRequest.getFilms({filmaffinity_id: film.filmaffinityId?.id}, (res) => {
                        resolve(res)
                    }, () => {
                        resolve([])
                    }))
                })
            }
            const ids = new Set((imdbMatches || []).map(d => d.id));
            const merged = [...(imdbMatches || []), ...(filmaMatches || []).filter(d => !ids.has(d.id))];
            ownProps.reducer.setDBFilms(merged)
            ownProps.reducer.setPendingFilm(film)
        },
        onSkip: () => {
            setPendingFilmToReview(film.id!, () => {
                getPendingFilm(ownProps)
            })
        }
    })
    ownProps.popUp.showPopUp(modal, true, true, () => {});
}

async function deleteDBFilm(film: FilmType) {
    return new Promise<void>((resolve, reject) => {
        if (!film.id) {
            reject("there's no film id")
            return
        }
        Network.instance.netClient.executeRequest(FilmRequest.deleteFilm(film.id, (res) => {
            console.log(res)
            resolve()
        }, (error) => {
            console.log(error)
            reject("Error in deleteFilm query")
        }))
    })

}

async function deletePendingFilm(id: number) {
    return new Promise<void>((resolve, reject) => {
        Network.instance.netClient.executeRequest(PendingFilmRequest.deletePendingFilm(id, (res) => {
            console.log(res)
            resolve()
        }, (error) => {
            console.log(error)
            reject("Error in deletePendingFilm query")
        }))
    })
}

async function createCommand(command: string, verify_exist_path: string | undefined, verify_not_exist_path: string | undefined) {
    return new Promise<void>((resolve, reject) => {
        Network.instance.netClient.executeRequest(PendingCommandRequest.postPendingCommand(command, verify_exist_path, verify_not_exist_path, (res) => {
            console.log(res)
            resolve()
        }, (error) => {
            console.log(error)
            reject("Error in postPendingCommand query")
        }))
    })
}

async function updateFilm(id: number, film: FilmType) {
    return new Promise<void>((resolve, reject) => {
        Network.instance.netClient.executeRequest(FilmRequest.updateFilms(id, film, (res) => {
            console.log(res)
            resolve()
        }, (error) => {
            console.log(error)
            reject("Error in postPendingCommand query")
        }))
    })
}

async function uploadPendingFilm(film: PendingFilmType) {
    return new Promise<void>((resolve, reject) => {
        console.log()
        const updateFilm: FilmType = {
            file_name: film.filename,
            folder: film.folder,
            filmaffinity_id: film.filmaffinityId?.id,
            imdb_id: film.imdbId?.id,
            size: film.size_mb,
            checksum: film.md5,
            format: film.extension,
            languages: (film.langs && film.langs !== '') ? film.langs?.split(',').map(it => it.trim()) : undefined,
            subtitles: (film.subs && film.subs !== '') ? film.subs?.split(',').map(it => it.trim()) : undefined,
        }
        Network.instance.netClient.executeRequest(FilmRequest.postFilmsAutocomplete([updateFilm], (res) => {
            console.log(res)
            resolve()
        }, (error) => {
            console.log(error)
            reject("Error in postFilmsAutocomplete query")
        }))
    })
}

export const mapProps = (ownProps: OwnPropsType & JoinedTypePropsType): InputPropsType => ({
    mode: ownProps.params.mode,
    films: Object.values(ownProps.reducer.films),
    duplicates: ownProps.reducer.duplicates
})

export const mapEvents = (ownProps: OwnPropsType & JoinedTypePropsType): EventPropsType => ({
    getPendingFilm: async () => {
        getPendingFilm(ownProps)
    },
    modifyPendingFilm: (film: ReviewFilmType) => {
        modifyPendingFilm(film.pending_data, ownProps)
    },
    setupFirstFolder: async () => {
        Network.instance.netClient.executeRequest(FilmRequest.getNextFolderAvailable((res) => {
            console.log(res)
            ownProps.reducer.setFirstFolder(res)
        }, (error) => {
            console.log(error)
        }))
    },
    skipPending: (id: number) => {
        setPendingFilmToReview(id, () => {
            getPendingFilm(ownProps)
        })
    },
    initializeDuplicates: async () => {
        Network.instance.netClient.executeRequest(FilmRequest.getDuplicates((res) => {
            console.log(res)
            ownProps.reducer.setDuplicates(res)
        }, (error) => {
            console.log(error)
        }))
    },
    getFilms: (ids: number[]) => {
        Network.instance.netClient.executeRequest(FilmRequest.getFilms({ids: ids}, async (res) => {
            console.log(res)
            ownProps.reducer.setDBFilms(res)
        }, () => {
        }))
    },
    setFilmToDelete: (id: number, toDelete: boolean) => {
        ownProps.reducer.setFilmToDelete(id, toDelete)
    },
    setFilmNewFolder: (id: number, folder: string) => {
        ownProps.reducer.setFilmFolder(id, folder)
    },
    save: async (onSuccess: () => void) => {
        const pendingFilm = Object.values(ownProps.reducer.films).find(film => {
            return film.pending_data
        })
        console.log('folder----> ', pendingFilm?.folder?.length)
        if (pendingFilm && !pendingFilm.toDelete && (pendingFilm.newFolder || pendingFilm.folder)?.length !== 4) {
            alert('Don\'t forget the correct folder')
            return
        }
        for (const filmKey in ownProps.reducer.films) {
            const film = ownProps.reducer.films[filmKey]
            try {
                const encodedFilename = encodePathToFileName(`${film.file_name?.replace(/\.[^/.]+$/, "")}.*`)
                if (film.toDelete) {
                    if (film.id !== pendingFilmId) {
                        await deleteDBFilm(film)
                        await createCommand(
                            `rm ${film.folder!.slice(0,2)}/${film.folder}/${encodedFilename}`,
                            undefined,
                            `${film.folder!.slice(0,2)}/${film.folder}/${encodedFilename}`
                        )
                    } else if (film.pending_data) {
                        await deletePendingFilm(film.pending_data.id!)
                        if (film.folder) {
                            await createCommand(
                                `rm ${film.pending_data.root_folder}${encodedFilename}`,
                                undefined,
                                `${film.pending_data.root_folder}${encodedFilename}`
                            )
                        } else {
                            await createCommand(
                                `rm ${film.pending_data.root_folder}${encodedFilename}`,
                                undefined,
                                `${film.pending_data.root_folder}${encodedFilename}`
                            )
                        }
                    }
                } else {
                    if (film.pending_data) {
                        await uploadPendingFilm({...film.pending_data, folder: film.newFolder || film.folder})
                        await deletePendingFilm(film.pending_data.id!)
                        await createCommand(
                            `mkdir ${(film.newFolder || film.folder!).slice(0, 2)}/${(film.newFolder || film.folder!)}/`,
                            `${(film.newFolder || film.folder!).slice(0, 2)}/${(film.newFolder || film.folder!)}/`,
                            undefined
                        )
                        const moveTargetFolder = `${(film.newFolder || film.folder!).slice(0, 2)}/${(film.newFolder || film.folder!)}/`
                        if (film.folder) {
                            await createCommand(
                                `mv ${film.pending_data.root_folder}${encodedFilename} ${moveTargetFolder}`,
                                `${moveTargetFolder}${encodedFilename}`,
                                `${film.pending_data.root_folder}${encodedFilename}`
                            )
                        } else {
                            await createCommand(
                                `mv ${film.pending_data.root_folder}${encodedFilename} ${moveTargetFolder}`,
                                `${moveTargetFolder}${encodedFilename}`,
                                `${film.pending_data.root_folder}${encodedFilename}`
                            )
                        }
                    } else {
                        if (film.newFolder && film.id) {
                            await updateFilm(film.id, film)
                            await createCommand(
                                `mkdir ${film.newFolder.slice(0,2)}/${film.newFolder}/`,
                                `${film.newFolder.slice(0,2)}/${film.newFolder}/`,
                                undefined
                            )
                            await createCommand(
                                `mv ${film.folder!.slice(0,2)}/${film.folder}/${encodedFilename} ${film.newFolder.slice(0,2)}/${film.newFolder}/`,
                                `${film.newFolder.slice(0,2)}/${film.newFolder}/${encodedFilename}`,
                                `${film.folder!.slice(0,2)}/${film.folder}/${encodedFilename}`,
                            )
                        }
                    }
                }
            } catch (e) {
                alert(`There are some errors with film ${film.id} :\n${e}`)
            }
        }
        ownProps.reducer.clearFilms()
        onSuccess()
    }
})

export default combineStates<JoinedTypePropsType, OwnPropsType, InputPropsType, EventPropsType>(View, mapProps, mapEvents, [
    reducer.createComponent('reducer', component_reducer, initState, dispatchToProps),
    context.createComponent('popUp', PopUpContext),
    createParamsComponent('params')
])
